<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="true" :crumbsShow="false" :cart_count="cart_count1" />
        <div class="box1">
            <div style="position: absolute; width: 100%; height: 430px; top: 0; left: 0; z-index: 99">
                <a-carousel :autoplay="true" style="width: 100%; height: 430px">
                    <div :key="index" v-for="(item, index) in index_banner" class="banner-container">
                        <a target="_blank" :href="item.url">
                            <div class="banner-info">
                                <div>{{ item.mainTitle }}</div>
                                <div>{{ item.subtitle }}</div>
                                <div>{{ item.describe }}</div>
                            </div>
                            <img v-if="item.picture" :src="'/api/file/preview/' + item.picture" style="min-width: 100%; min-height: 100%" />
                        </a>
                    </div>
                </a-carousel>
            </div>
            <div style="margin: auto; width: 1239px; height: 100%; position: relative">
                <div style="position: relative; z-index: 999; width: 290px; margin-right: 19px; float: right; height: 430px; background: rgba(0, 0, 0, 0.2)">
                    <swiperRight />
                </div>
            </div>
        </div>
        <div class="box2" style="overflow: hidden; height: 130px">
            <a-row :gutter="16">
                <a-col v-for="(i, index) in list_quick" :key="index" class="gutter-row" :span="6">
                    <a class="gutter-box" style="position: relative" :href="i.url" target="_blank">
                        <img :src="i.picture" class="lebiao1_img" />
                        <div class="index_txt_img_1">
                            <div class="img_wenzi1">{{ i.mainTitle }}</div>
                            <div class="img_wenzi2">{{ i.subtitle }}</div>
                        </div>
                    </a>
                </a-col>
            </a-row>
        </div>

        <div style="overflow: hidden; width: 50%; margin: auto; margin-top: 40px; margin-bottom: 0; display: flex; justify-content: center; align-items: center">
            <div class="box3"></div>
            <span style="float: left; padding: 0 4%">
                <span style="font-size: 30px; font-weight: Regular">这是科隆化学</span>
                / This is Kelong Chemical</span
            >
            <div class="box3"></div>
        </div>

        <div class="box2 information" style="margin-top: 0; overflow: hidden">
            <a-row :gutter="16">
                <template v-for="(i, index) in list_information">
                    <a-col :key="index" class="gutter-row" :span="12" style="height: 500px; margin-top: 16px; padding-right: 8px">
                        <a :href="i.url" target="_blank" class="gutter-box" style="position: relative; cursor: pointer">
                            <img :src="i.picture" class="box4" />
                            <div class="index_box1_img">
                                <div style="overflow: hidden">
                                    <h2>{{ i.mainTitle }}</h2>
                                    <p>{{ i.subtitle }}</p>
                                    <img src="../assets/index_jiantou.png" style="margin: 20px auto; width: 40px; display: block" />
                                </div>
                            </div>
                        </a>
                    </a-col>
                </template>
            </a-row>
        </div>

        <foot />

        <a-modal centered :visible="visible" :footer="null" :width="480" :height="240" @cancel="cancel">
            <div class="pop_title">
                <div style="text-align: center">您已注册成功！</div>
                <div style="text-align: center">请前去设置登录密码</div>
            </div>
            <div style="overflow: hidden; width: 50%; margin: 40px auto">
                <router-link :to="{ name: 'register' }"><div class="pop_left_bue">确定</div></router-link>

                <div @click="visible = false" class="pop_left_bue" style="float: right; border: 1px solid #ede9e9; color: #666; background: #fff">取消</div>
            </div>
        </a-modal>
        <a-modal centered :visible="visible2" :footer="null" :width="480" :height="240" @cancel="cancel">
            <div class="pop_title">
                <div style="text-align: center">您已注册成功！</div>
                <div style="text-align: center">请前去完善企业信息</div>
            </div>
            <div style="overflow: hidden; width: 50%; margin: 40px auto">
                <router-link :to="{ name: 'enterprise_info' }"><div class="pop_left_bue">确定</div></router-link>

                <div @click="visible2 = false" class="pop_left_bue" style="float: right; border: 1px solid #ede9e9; color: #666; background: #fff">取消</div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import swiperRight from '../public/swiper_right';
export default {
    name: 'index',
    components: {
        htmlHeader,
        foot,
        swiperRight
    },
    data() {
        return {
            visible: false, //设置密码弹框
            visible2:false,//完善企业信息
            swiper_right_box: ['交易流程', '免费找货', '代理商申请', '供应商入驻'],
            swiper_right_box_index: 0, //切换索引
            index_banner: [], //轮播图
            index_quickEntry: [], //轮播图
            index_information: [], //轮播图
            index_bottomEntry: [], //轮播图
            index_picInfo: [], //轮播图
            index_customerService: [], //轮播图
            cart_count1: 0,
            list_quick: [],
            list_information: []
        };
    },
    methods: {
        cancel() {
            this.visible = false;
        },
        // 切换
        changSwiperRightBox(e) {
            this.swiper_right_box_index = e;
        },
        // 是否设置了密码
        get_is_pwdSetFirst() {
            this.api.is_pwdSetFirst().then(res => {
                if (!res.data) {
                    this.visible = true;
                } else {
                    this.api.is_pwdSetFirst2().then(res => {
                        if (!res.data & (res.status != 'error')) {
                            this.visible2 = true;
                        }
                    });
                }
            });
        },
        // 获取首页所有数据
        get_index_all_data() {
            // banner
            this.api.get_index_banner().then(res => {
                if (res.ok) {
                    this.index_banner = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
            // 首页快速入口
            this.api.get_index_quickEntry().then(res => {
                if (res.ok) {
                    const data = JSON.parse(res.data.description);
                    const list = [[], []];
                    data.forEach((i, index) => {
                        i.picture = `/api/file/preview/${i.picture}`;
                        if (index < 4) {
                            list[0].push(i);
                        } else {
                            list[1].push(i);
                        }
                    });
                    this.list_quick = list[0];
                    this.list_information = list[1];
                } else {
                    this.$message.error(res.message);
                }
            });
            // 首页资讯
            // this.api.get_index_information().then((res) => {
            //     if (res.ok) {
            //         const data = JSON.parse(res.data.description)
            //         data.forEach(i => {
            //           i.picture = `/api/file/preview/${i.picture}`
            //           i.subtitle = i.subtitle || '了解更多'
            //           i.url = `/news_details?uuid=${i.uuid}`
            //         })
            //         this.list_information = data
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // });
            // 底部入口链接
            this.api.get_index_bottomEntry().then(res => {
                if (res.ok) {
                    this.index_bottomEntry = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
            // 底部二维码文字
            this.api.get_index_picInfo().then(res => {
                if (res.ok) {
                    this.index_picInfo = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
            // 底部客服信息
            this.api.get_index_customerService().then(res => {
                if (res.ok) {
                    this.index_customerService = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    },
    created() {
        if (localStorage.username) {
            this.get_is_pwdSetFirst();
        }
        this.get_index_all_data();
    }
};
</script>
<style scoped>
/* 轮播图 */
.banner-container {
    position: relative;
    height: 430px;
}
.banner-info {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0 60px;
    width: 710px;
    color: white;
}
.banner-info > div:first-child {
    margin-top: 100px;
    font-size: 30px;
    line-height: 28px;
}
.banner-info > div:nth-child(2) {
    margin: 10px 0 30px;
    font-size: 14px;
}
.banner-info > div:last-child {
    font-size: 18px;
    white-space: pre;
}

/* 快速入口 */
.gutter-row > a {
    display: block;
}
.gutter-row > a > img {
    object-fit: cover;
}

/* 信息 */
.information {
    text-align: center;
}
.information h2 {
    font-size: 36px;
    color: white;
}
.information h2 + p {
    font-size: 24px;
    color: white;
}

.ant-carousel >>> .slick-slide h3 {
    color: #fff;
}

.txtx12 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 10px;
}

.bangmangzhaohou {
    width: 260px;
    height: 32px;
    background: #2b9a34;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fdfeff;
    line-height: 32px;
    margin: 20px auto;
    margin-bottom: 0;
}

.swiper_right_box_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: 5px;
}

.swiper_right_box_top_jylc_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    margin-top: 20px;
}

.swiper_right_box_top_active {
    background: #fff !important;
    color: #2b9a34;
}

.swiper_right_box_top {
    width: 100%;
    height: 10%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    line-height: 50px;
}

.box5 {
    min-height: 1023px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-top: 4%;
    text-align: center;
}

.box4 {
    width: 100%;
    height: 500px;
    position: absolute;
    top: 0;
    left: 0;
}

.box3 {
    width: 60px;
    height: 1px;
    border: 1px solid #2b9a34;
    float: left;
    margin-top: 1%;
}

.box2 {
    width: 1200px;
    margin: 30px auto;
}

h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

.box1 {
    width: 100%;
    height: 430px;
    background: rgb(238, 236, 236);
    position: relative;
}

.slick-slider {
    height: 574px !important;
}

.slick-initialized {
    height: 574px !important;
}

.slick-list {
    height: 574px !important;
}

.ant-carousel .slick-list .slick-slide.slick-active {
    height: 574px !important;
}

.lebiao1_img {
    width: 100%;
    height: 130px;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
}

.index_txt_img_1 {
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 130px;
    position: absolute;
    top: 0;
    left: 0;
}

.img_wenzi1 {
    font-size: 24px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-top: 30px;
}

.img_wenzi2 {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R;
    font-weight: Regular;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
}

.index_box1_img {
    width: 100%;
    height: 500px;
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s;
}

.index_box1_img:hover {
    background-color: rgba(0, 0, 0, 0.4);
}

.pop_tisp {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 20px;
}

.pop_left_bue {
    width: 100px;
    height: 40px;
    background: #2b9a34;
    float: left;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.pop_title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue